import * as abf from 'ayvri-bin-fmt';
import * as abf3 from 'ayvri-bin-fmt/lib/abf3';
// file to grab the activity type file with appropriate correction applied.
const extensions = {
    1: '.ground',
    2: '.aerial',
    3: '.mixed',
    4: '.wa',
};
export function downloadFrames(endpoint, activities, offsets, counts, digest = false) {
    const url = new URL(endpoint);
    function toEctString(act) {
        return act.elevationCorrectionType === 0 ? 'ground' : 'aerial';
    }
    // Construct the query params
    const params = activities.map((a, i) => {
        const frameHint = a.abf.maxChunkSize;
        const count = Math.max(0, counts[i]);
        return `${a.activityIdx},${toEctString(a)},${offsets[i]},${count},${frameHint}`;
    });
    // Request the digest
    if (digest)
        params.digests = true;
    // This turns on 3.1 frames. It should eventually go into the accepts header, and the
    // supported versions should be supplied by abf3.
    params.version = '3.1';
    // Install the URL params and do the fetch
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
    return fetch(url).then(res => {
        if (res.status !== 200) {
            return Promise.reject(new Error(`Failed to download frame, status ${res.status}`));
        }
        return res.arrayBuffer().then(data => {
            const view = new Uint8Array(data);
            return abf3.decode(view);
        });
    });
}
export default function downloadTrack(activity, onPointsLoaded) {
    const xhr = new XMLHttpRequest();
    // Request byte data
    xhr.open('GET', activity.pathUrl + extensions[activity.elevationCorrectionType || 4], true);
    // @NOTE: If we request an arraybuffer response, we will only get the data once it is fully loaded (i.e. no streaming)
    xhr.responseType = 'arraybuffer';
    xhr.onload = err => {
        const hasError = xhr.status >= 400;
        if (hasError) {
            xhr.onerror(err);
        }
        else {
            const arrayBuffer = xhr.response;
            const contentType = xhr.getResponseHeader('Content-Type') || '';
            const points = processData(arrayBuffer, contentType);
            onPointsLoaded(points, xhr.response.length, true);
        }
    };
    xhr.onerror = function (err) {
        self.postMessage({
            activityId: activity.activityId,
            error: true,
            statusCode: err.statusCode,
        });
        xhr.abort();
    };
    function processData(buffer, contentType) {
        if (buffer.byteLength === 0)
            return [];
        const isAbf3 = /.*application\/abf\.v3.*/.test(contentType);
        if (isAbf3) {
            return abf3.decode(new Uint8Array(buffer)).frames.reduce((c, v) => c.concat(v.frame), []);
        }
        else {
            const header = {};
            const headerView = new DataView(buffer);
            const offset = abf.jsonifyBinaryHeader(headerView, header);
            const rawPoints = [];
            const pointsView = new DataView(buffer, offset);
            abf.jsonifyBinaryPoints(pointsView, header, rawPoints);
            return rawPoints;
        }
    }
    // Send request
    xhr.send();
}
